import TopOnlineReviewsLogo from './logo'
import {topOnlineReviewsStylesCA, topOnlineReviewsStylesUK} from './styles'

const baseConfig = {
  domainName: 'toponlinereviews' as const,
  domainType: 'brg' as const,
  siteName: 'Top Online Reviews',
  favicon: '/favicons/toponlinereviews.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-L6JE4EZT52',
    camelCaseUrl: 'TopOnlineReviews.co.uk',
    logo: <TopOnlineReviewsLogo className="size-10 shrink-0 tablet:size-8" locale="uk" />,
    title: (category: string, count: string) =>
      `Top ${count} Best Reviewed ${category} in the UK | There's One Clear Winner | TopOnlineReviews.co.uk`,
    description: (_category?: string, _count?: string) =>
      `TopOnlineReviews.co.uk – Top UK reviews on thousands of products. Find the top-rated items at today's lowest prices, all in one place!`,
    styles: topOnlineReviewsStylesUK,
  },
  ca: {
    measurementId: 'G-2NPY07NP7H',
    camelCaseUrl: 'TopOnlineReviews.ca',
    logo: <TopOnlineReviewsLogo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
    title: (category: string, count: string) =>
      `Top ${count} Best Reviewed ${category} in CA | There's One Clear Winner | TopOnlineReviews.ca`,
    description: (_category?: string, _count?: string) =>
      `TopOnlineReviews.ca – Top CA reviews on thousands of products. Find the top-rated items at today's lowest prices, all in one place!`,
    styles: topOnlineReviewsStylesCA,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
